var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74079 1.27205C7.97315 0.556905 8.98489 0.556903 9.21725 1.27205L10.6574 5.70447C10.7614 6.02429 11.0594 6.24083 11.3957 6.24083H16.0562C16.8081 6.24083 17.1208 7.20304 16.5124 7.64503L12.742 10.3844C12.4699 10.5821 12.3561 10.9324 12.46 11.2523L13.9002 15.6847C14.1326 16.3998 13.3141 16.9945 12.7057 16.5525L8.93527 13.8131C8.66322 13.6155 8.29482 13.6155 8.02277 13.8131L4.25233 16.5525C3.64399 16.9945 2.82548 16.3998 3.05784 15.6847L4.49802 11.2523C4.60194 10.9324 4.4881 10.5821 4.21604 10.3844L0.445599 7.64503C-0.162738 7.20305 0.149904 6.24083 0.901851 6.24083H5.56237C5.89865 6.24083 6.19669 6.02429 6.30061 5.70447L7.74079 1.27205Z",
    fill: "#6EAEFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/Star-filled.9da4942cdeb5bfe32b3d36659d339cf8.svg";
export { ForwardRef as ReactComponent };